export default __webpack_public_path__ + "static/gain-65d301f31da898b4c258f65711394188.jpg";